module.exports = "/assets/8aeaceedf70aee76156da09f24325a63.jpg";